export const themeStyles = (props) => {

    // eslint-disable-next-line
    const {
        //width,
        //height,
        //currentBreakpoint,
        //isXXS,
        //isXS,
        //isSM,
        //isMD,
        //isLG,
        //isXLG,
        //breakPoints,
        //matches,
        //evaluate
    } = props;

    const GENERAL_ROW_FIX = {
        marginLeft: '-15px',
        //marginRight: '-15px'
    };

    return {
        GENERAL_ROW_FIX,
    };
};